import { Hint } from "@ui-kit/components/index.es";
import classNames from "classnames";
import { Field, Form, withFormik } from "formik";
import moment from "moment";
import Button from "pages/_components/Button";
import Head from "pages/_components/Head";
import I18n from "pages/_components/I18n";
import Notification from "pages/_components/Notification";
import PageLoading from "pages/_components/PageLoading";
import TabletSelectors from "pages/_components/TabletSelectors";
import { DateField } from "pages/_components/fields/DateField";
import TextField from "pages/_components/fields/TextField";
import Selector from "pages/_components/fields/formik/Selector";
import RangeDatePicker from "pages/_components/fields/rangedatepicker/RangeDatePicker";
import EcomexInformativeRegimeDetail from "pages/ecomex/_components/EcomexInformativeRegimeDetail";
import EcomexInformativeRegimeList from "pages/ecomex/_components/EcomexInformativeRegimeList";
import { arrayOf, bool, func, number, shape, string } from "prop-types";
import React, { Component } from "react";
import { connect } from "react-redux";
import { push } from "react-router-redux";
import { actions as ecomexActions, selectors as ecomexSelectors } from "reducers/ecomex";
import { compose } from "redux";
import * as configUtils from "util/config";
import { evalEqualsValues } from "util/form";
import * as i18nUtils from "util/i18n";
import Yup from "yup";
import { resizableRoute } from "pages/_components/Resizable";
import { DownloadButton } from "v3/components/DownloadButton";
import { applyEmbeddedV3ShellLayoutState, clearEmbeddedV3ShellLayoutState } from "util/v3ShellLayoutSync";

const FORM_ID = "ecomex.informativeRegime.list";
const DATE_FROM = moment()
    .subtract(30, "days")
    .toDate();
const DATE_TO = new Date();

class EcomexInformativeRegimeMain extends Component {
    static propTypes = {
        fetching: bool.isRequired,
        isDesktop: bool.isRequired,
        dispatch: func.isRequired,
        fetchingDownload: bool.isRequired,
        ecomexInformativeRegime: arrayOf(shape({})).isRequired,
        filtersData: shape({}).isRequired,
        values: shape({}).isRequired,
        operationsTypes: arrayOf(shape({})).isRequired,
        optionSelected: string.isRequired,
        setFieldValue: func.isRequired,
        selectedInformativeRegime: shape({}).isRequired,
        pageNumber: number.isRequired,
        numberPerPage: number.isRequired,
        ecomexStates: arrayOf(string).isRequired,
        optionSelectedFromPre: number.isRequired,
        setValues: func.isRequired,
        embeddedInV3Shell: bool,
    };

    static defaultProps = {
        embeddedInV3Shell: false,
    };

    state = {
        selectedPayDateFrom: null,
        selectedDueDateFrom: null,
        selectedOfficialDateFrom: null,
        selectedSettlementDateFrom: null,
        selectedEmbDateFrom: null,
        showForm: false,
        filtersActive: false,
    };

    componentDidMount() {
        const { dispatch, optionSelected } = this.props;

        dispatch(
            ecomexActions.listEcomexInformativeRegimePre(optionSelected, this.getDefaultEcomexState(optionSelected)),
        );
        this.syncEmbeddedV3ShellLayout();
    }

    componentDidUpdate(prevProps) {
        const {
            ecomexStates,
            operationsTypes,
            numberPerPage,
            pageNumber,
            dispatch,
            optionSelectedFromPre,
            selectedInformativeRegime,
            setValues,
            filtersData,
            values,
            embeddedInV3Shell,
            isDesktop,
            fetching,
            fetchingDownload,
        } = this.props;

        if (prevProps.selectedInformativeRegime !== selectedInformativeRegime && !selectedInformativeRegime) {
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            setValues({
                ...values,
                ...filtersData,
                ...(enableRangeDatefield && {
                    payDates: [filtersData.payDateFrom, filtersData.payDateTo],
                    dueDates: [filtersData.dueDateFrom, filtersData.dueDateTo],
                    officialDates: [filtersData.officialDateFrom, filtersData.officialDateTo],
                    settlementDates: [filtersData.settlementDateFrom, filtersData.settlementDateTo],
                    embDates: [filtersData.embDateFrom, filtersData.embDateTo],
                }),
            });
        }
        if (prevProps.optionSelectedFromPre !== optionSelectedFromPre) {
            dispatch(
                ecomexActions.listEcomexInformativeRegime(
                    pageNumber,
                    numberPerPage,
                    optionSelectedFromPre,
                    ecomexStates && this.getDefaultEcomexState(optionSelectedFromPre),
                    operationsTypes && operationsTypes[0] && operationsTypes[0].value,
                    "",
                    "",
                    null,
                    null,
                    null,
                    null,
                    DATE_FROM,
                    DATE_TO,
                    DATE_FROM,
                    DATE_TO,
                    DATE_FROM,
                    DATE_TO,
                ),
            );
        }
        if (embeddedInV3Shell) {
            const shellOrViewportChanged =
                prevProps.embeddedInV3Shell !== embeddedInV3Shell || prevProps.isDesktop !== isDesktop;
            const routeChanged = prevProps.selectedInformativeRegime !== selectedInformativeRegime;
            const listMobileDepsChanged =
                !isDesktop &&
                !selectedInformativeRegime &&
                (prevProps.fetching !== fetching || prevProps.fetchingDownload !== fetchingDownload);
            if (shellOrViewportChanged || routeChanged || listMobileDepsChanged) {
                this.syncEmbeddedV3ShellLayout();
            }
        }
    }

    componentWillUnmount() {
        const { embeddedInV3Shell, dispatch } = this.props;
        if (embeddedInV3Shell) {
            clearEmbeddedV3ShellLayoutState(dispatch);
        }
    }

    syncEmbeddedV3ShellLayout = () => {
        const { dispatch, embeddedInV3Shell, isDesktop, selectedInformativeRegime, fetchingDownload } = this.props;
        if (!embeddedInV3Shell) {
            return;
        }
        if (selectedInformativeRegime) {
            const ref =
                selectedInformativeRegime.referenciaOperacion ||
                selectedInformativeRegime.destinacion ||
                selectedInformativeRegime.refOp ||
                "";
            applyEmbeddedV3ShellLayoutState(dispatch, {
                embeddedInV3Shell,
                isDesktop,
                scopes: ["ecomexInformativeRegime/details"],
                headerTitle: String(ref),
                goBackPath: "/ecomex/informativeRegime",
                rightContentMobile: !isDesktop ? null : undefined,
            });
        } else {
            applyEmbeddedV3ShellLayoutState(dispatch, {
                embeddedInV3Shell,
                isDesktop,
                scopes: [FORM_ID],
                titleKey: "menu.ecomex.informativeRegime",
                goBackPath: "/v3/dashboard",
                rightContentMobile: !isDesktop ? (
                    <DownloadButton
                        handleClick={this.handleExport}
                        isFetchingExport={fetchingDownload}
                        downloadImageWhite
                    />
                ) : (
                    undefined
                ),
            });
        }
    };

    handleChangePayDateFrom = (selectedDate) => {
        this.setState({ selectedPayDateFrom: selectedDate });
    };

    handleChangeDueDateFrom = (selectedDate) => {
        this.setState({ selectedDueDateFrom: selectedDate });
    };

    handleChangeOfficialDateFrom = (selectedDate) => {
        this.setState({ selectedOfficialDateFrom: selectedDate });
    };

    handleChangeSettlementDateFrom = (selectedDate) => {
        this.setState({ selectedSettlementDateFrom: selectedDate });
    };

    handleChangeEmbDateFrom = (selectedDate) => {
        this.setState({ selectedEmbDateFrom: selectedDate });
    };

    handleBack = () => {
        const { dispatch, embeddedInV3Shell } = this.props;
        if (embeddedInV3Shell) {
            dispatch(push("/v3/dashboard"));
            return;
        }
        dispatch(push("/desktop"));
    };

    handleExport = (format) => {
        const {
            dispatch,
            ecomexInformativeRegime,
            filtersData,
            optionSelected,
            pageNumber,
            numberPerPage,
        } = this.props;

        const ecomexInformativeRegimeToShow = ecomexInformativeRegime.slice(
            numberPerPage * (pageNumber - 1),
            numberPerPage * pageNumber,
        );

        const summary = { ecomexInformativeRegime: ecomexInformativeRegimeToShow, optionSelected, filtersData };
        dispatch(ecomexActions.downloadInformativeRegimeList(summary, format));
    };

    getDefaultEcomexState = (option) => {
        switch (option) {
            case "1":
            case "3":
                return "V";
            case "2":
                return "";
            case "4":
                return "Pendiente";
            default:
                return "";
        }
    };

    changeOption = (option) => {
        const { dispatch, ecomexStates, operationsTypes } = this.props;
        dispatch(ecomexActions.listEcomexInformativeRegimePre(option));
        dispatch(
            ecomexActions.saveOptionSelectedForRegime(
                option,
                ecomexStates && this.getDefaultEcomexState(option),
                operationsTypes && operationsTypes[0] && operationsTypes[0].value,
                "",
                "",
                null,
                null,
                null,
                null,
                DATE_FROM,
                DATE_TO,
                DATE_FROM,
                DATE_TO,
                DATE_FROM,
                DATE_TO,
            ),
        );
        this.clearFilters(option, false);
    };

    clearFilters = (option, fromClearFilterButton) => {
        const { setFieldValue, ecomexStates, operationsTypes, numberPerPage, pageNumber, dispatch } = this.props;

        setFieldValue("ecomexState", ecomexStates && this.getDefaultEcomexState(option));
        setFieldValue("operationType", operationsTypes && operationsTypes[0] && operationsTypes[0].value);
        setFieldValue("destination", "");
        setFieldValue("operationNumber", "");
        setFieldValue("payDateFrom", null);
        setFieldValue("payDateTo", null);
        setFieldValue("payDates", [null, null]);
        setFieldValue("dueDateFrom", null);
        setFieldValue("dueDateTo", null);
        setFieldValue("dueDates", [null, null]);
        setFieldValue("officialDateFrom", DATE_FROM);
        setFieldValue("officialDateTo", DATE_TO);
        setFieldValue("officialDates", [DATE_FROM, DATE_TO]);
        setFieldValue("settlementDateFrom", DATE_FROM);
        setFieldValue("settlementDateTo", DATE_TO);
        setFieldValue("settlementDates", [DATE_FROM, DATE_TO]);
        setFieldValue("embDateFrom", DATE_FROM);
        setFieldValue("embDateTo", DATE_TO);
        setFieldValue("embDates", [DATE_FROM, DATE_TO]);
        this.setState((prevState) => ({
            ...prevState,
            filtersActive: false,
        }));
        if (fromClearFilterButton) {
            dispatch(
                ecomexActions.listEcomexInformativeRegime(
                    pageNumber,
                    numberPerPage,
                    option,
                    ecomexStates && this.getDefaultEcomexState(option),
                    operationsTypes && operationsTypes[0] && operationsTypes[0].value,
                    "",
                    "",
                    null,
                    null,
                    null,
                    null,
                    DATE_FROM,
                    DATE_TO,
                    DATE_FROM,
                    DATE_TO,
                    DATE_FROM,
                    DATE_TO,
                ),
            );
        }
    };

    theFiltersAreChanged = () => {
        const { values, optionSelected } = this.props;

        const {
            ecomexState,
            destination,
            operationNumber,
            payDateFrom,
            payDateTo,
            payDates,
            dueDateFrom,
            dueDateTo,
            dueDates,
            officialDateFrom,
            officialDateTo,
            officialDates,
            settlementDateFrom,
            settlementDateTo,
            settlementDates,
            embDateFrom,
            embDateTo,
            embDates,
            operationType,
        } = values;

        const dateFrom = DATE_FROM;
        const dateTo = DATE_TO;
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);

        const isSetelementDateFrom =
            (enableRangeDatefield && settlementDates[0] ? settlementDates[0] : settlementDateFrom).toDateString() ===
            dateFrom.toDateString();
        const isSetelementDateTo =
            (enableRangeDatefield && settlementDates[1] ? settlementDates[1] : settlementDateTo).toDateString() ===
            dateTo.toDateString();

        const isOfficialDateFrom =
            (enableRangeDatefield && officialDates[0] ? officialDates[0] : officialDateFrom).toDateString() ===
            dateFrom.toDateString();
        const isOfficialDateTo =
            (enableRangeDatefield && officialDates[1] ? officialDates[1] : officialDateTo).toDateString() ===
            dateTo.toDateString();

        const isEmbDateFrom =
            (enableRangeDatefield && embDates[0] ? embDates[0] : embDateFrom).toDateString() ===
            dateFrom.toDateString();
        const isEmbDateTo =
            (enableRangeDatefield && embDates[1] ? embDates[1] : embDateTo).toDateString() === dateTo.toDateString();

        const emptyFieldsHaveChanged = !(
            !destination &&
            !operationNumber &&
            !payDateFrom &&
            !payDateTo &&
            payDates.every((d) => !d) &&
            !dueDateFrom &&
            !dueDateTo &&
            dueDates.every((d) => !d) &&
            isOfficialDateFrom &&
            isOfficialDateTo &&
            isSetelementDateFrom &&
            isSetelementDateTo &&
            isEmbDateFrom &&
            isEmbDateTo &&
            !operationType
        );
        if (
            emptyFieldsHaveChanged ||
            !(
                (ecomexState === "V" && optionSelected === "1") ||
                (!ecomexState && optionSelected === "2") ||
                (ecomexState === "V" && optionSelected === "3")
            )
        ) {
            this.setState((prevState) => ({
                ...prevState,
                filtersActive: true,
            }));
        } else {
            this.setState((prevState) => ({
                ...prevState,
                filtersActive: false,
            }));
        }
    };

    rowButtons = () => {
        const { isDesktop, optionSelected } = this.props;
        const { showForm, filtersActive } = this.state;

        const possibleOptions = ["1", "2", "3", "4"];

        const options = possibleOptions.map((possibleOption) => ({
            value: possibleOption,
            label:
                possibleOption === "2" && !isDesktop
                    ? `ecomex.informativeRegime.2.mobile.label`
                    : `ecomex.informativeRegime.${possibleOption}.label`,
        }));

        return (
            <div className={isDesktop && "d-flex space-between align-items-center w-100 background-white mb-3 px-3"}>
                <TabletSelectors
                    isDesktop={isDesktop}
                    possibleOptions={options}
                    changeOption={this.changeOption}
                    optionSelected={optionSelected}
                    containerClass={classNames("ecomex-tablet-selector", {
                        "py-3 w-100 flex-5": isDesktop,
                        "my-0 py-3": !isDesktop,
                    })}
                />
                {isDesktop && (
                    <div className="hide-filter__btn-content flex">
                        <div className="d-flex align-items-center flex-column justify-content-center">
                            <Button
                                block
                                bsStyle="outline"
                                className="hide-filter__btn m-0"
                                label={
                                    showForm
                                        ? "global.hide.filter"
                                        : `${filtersActive ? "global.filter.active" : "global.see.filter"}`
                                }
                                image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                            />
                            {filtersActive && (
                                <Button
                                    label="echeq.clean.filters"
                                    className="hide-filter__clean-btn"
                                    onClick={() => this.clearFilters(optionSelected, true)}
                                    image="images/cross.svg"
                                    imageStyle="circle-cross"
                                />
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    };

    renderList() {
        const {
            fetching,
            values,
            operationsTypes,
            isDesktop,
            optionSelected,
            ecomexStates,
            setFieldValue,
            filtersData,
        } = this.props;

        const {
            selectedPayDateFrom,
            selectedDueDateFrom,
            selectedOfficialDateFrom,
            selectedSettlementDateFrom,
            selectedEmbDateFrom,
            showForm,
            filtersActive,
        } = this.state;

        const {
            payDateFrom,
            payDateTo,
            dueDateFrom,
            dueDateTo,
            officialDateFrom,
            officialDateTo,
            settlementDateFrom,
            settlementDateTo,
            embDateFrom,
            embDateTo,
            ecomexState,
            operationType,
        } = values;

        const ecomexStatesOptions = ecomexStates.map((state) => ({ value: state.value, label: state.description }));
        const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
        const enableNewSubmitButton = configUtils.getBoolean("frontend.Show.FilterButton.Functionalities", false);

        const operationsTypesOptions = operationsTypes.map((operationT) => ({
            value: operationT.value,
            label: operationT.description,
        }));

        if (ecomexStates.length > 0 && !ecomexState && ecomexState !== "") {
            setFieldValue("ecomexState", this.getDefaultEcomexState(optionSelected));
        }

        if (operationsTypes.length > 0 && !operationType && operationType !== "") {
            setFieldValue("operationType", operationsTypes[0].value);
        }

        const filterButton = (
            <div
                className={classNames("d-flex align-items-start btn-filter_container px-2 p-relative", {
                    "mt-4": isDesktop,
                })}>
                <Button
                    bsStyle="primary"
                    label={`${FORM_ID}.search.button`}
                    loading={fetching}
                    type="submit"
                    onClick={() => this.theFiltersAreChanged()}
                    image={enableNewSubmitButton ? "filter-icon.svg" : undefined}
                    imageStyle="mr-2"
                    className={classNames(
                        "filter-button w-100",
                        { "text-transform-none": enableNewSubmitButton },
                        { "mt-25 mx-0": isDesktop },
                    )}
                    disabled={
                        enableNewSubmitButton &&
                        evalEqualsValues(
                            filtersData,
                            values,
                            [
                                "optionSelected",
                                "quantityPerPage",
                                ...(optionSelected === "2" ? ["ecomexState"] : []),
                                ...(optionSelected !== "1" ? ["operationNumber"] : []),
                                ...(optionSelected !== "1" || !enableRangeDatefield ? ["payDates"] : []),
                                ...(optionSelected !== "1" || enableRangeDatefield ? ["payDateFrom", "payDateTo"] : []),
                                ...((optionSelected !== "1" && optionSelected !== "4") || !enableRangeDatefield
                                    ? ["dueDates"]
                                    : []),
                                ...((optionSelected !== "1" && optionSelected !== "4") || enableRangeDatefield
                                    ? ["dueDateFrom", "dueDateTo"]
                                    : []),
                                ...(optionSelected !== "2" && optionSelected !== "3" ? ["operationType"] : []),
                                ...(optionSelected !== "2" || !enableRangeDatefield ? ["settlementDates"] : []),
                                ...(optionSelected !== "2" || enableRangeDatefield
                                    ? ["settlementDateFrom", "settlementDateTo"]
                                    : []),
                                ...(optionSelected !== "3" && optionSelected !== "4" ? ["destination"] : []),
                                ...(optionSelected !== "3" || !enableRangeDatefield ? ["officialDates"] : []),
                                ...(optionSelected !== "3" || enableRangeDatefield
                                    ? ["officialDateFrom", "officialDateTo"]
                                    : []),
                                ...(optionSelected !== "4" || !enableRangeDatefield ? ["embDates"] : []),
                                ...(optionSelected !== "4" || enableRangeDatefield ? ["embDateFrom", "embDateTo"] : []),
                            ],
                            [
                                ...(optionSelected === "1" && enableRangeDatefield ? ["payDates"] : []),
                                ...(optionSelected === "1" && !enableRangeDatefield
                                    ? ["payDateFrom", "payDateTo"]
                                    : []),
                                ...(optionSelected === "1" && enableRangeDatefield ? ["dueDates"] : []),
                                ...(optionSelected === "1" && !enableRangeDatefield
                                    ? ["dueDateFrom", "dueDateTo"]
                                    : []),
                                ...(optionSelected === "2" && enableRangeDatefield ? ["settlementDates"] : []),
                                ...(optionSelected === "2" && !enableRangeDatefield
                                    ? ["settlementDateFrom", "settlementDateTo"]
                                    : []),
                                ...(optionSelected === "3" && enableRangeDatefield ? ["officialDates"] : []),
                                ...(optionSelected === "3" && !enableRangeDatefield
                                    ? ["officialDateFrom", "officialDateTo"]
                                    : []),
                                ...(optionSelected === "4" && enableRangeDatefield ? ["dueDates"] : []),
                                ...(optionSelected === "4" && !enableRangeDatefield
                                    ? ["dueDateFrom", "dueDateTo"]
                                    : []),
                                ...(optionSelected === "4" && enableRangeDatefield ? ["embDates"] : []),
                                ...(optionSelected === "4" && !enableRangeDatefield
                                    ? ["embDateFrom", "embDateTo"]
                                    : []),
                            ],
                        )
                    }
                />
            </div>
        );

        return (
            <PageLoading loading={fetching}>
                {!isDesktop && (
                    <div className="justify-content-end d-flex">
                        <div className="hide-filter__btn-content my-3">
                            <Button
                                bsStyle="outline"
                                className="hide-filter__btn m-0"
                                image={showForm ? "images/eye-off.svg" : "images/eye.svg"}
                                label={
                                    showForm
                                        ? "global.hide.filter"
                                        : `${filtersActive ? "global.filter.active" : "global.see.filter"}`
                                }
                                onClick={() => this.setState((prev) => ({ ...prev, showForm: !prev.showForm }))}
                            />
                            {filtersActive && (
                                <Button
                                    label="global.clean.filters"
                                    className="hide-filter__clean-btn"
                                    onClick={() => this.clearFilters(optionSelected, true)}
                                    image="images/cross.svg"
                                    imageStyle="circle-cross"
                                />
                            )}
                        </div>
                    </div>
                )}
                {showForm && (
                    <Form autoComplete="off">
                        <div className={classNames("filtros-ecomex-ri", "ecomex__form")}>
                            {optionSelected === "1" && (
                                <>
                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={Selector}
                                            options={ecomexStatesOptions}
                                            idForm={`${FORM_ID}.search`}
                                            name="ecomexState"
                                            isRequired
                                            hidePlaceholder
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                        />
                                    </div>
                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={TextField}
                                            hidePlaceholder
                                            idForm={`${FORM_ID}.search`}
                                            name="operationNumber"
                                            type="text"
                                            pattern="[0-9]*"
                                            maxLength={6}
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                        />
                                    </div>
                                    {enableRangeDatefield ? (
                                        <>
                                            <div
                                                className={classNames(
                                                    "d-flex align-items-start rangedate-picker__container  px-2",
                                                    {
                                                        "w-100": !isDesktop,
                                                    },
                                                )}>
                                                <Field
                                                    component={RangeDatePicker}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="payDates"
                                                />
                                            </div>
                                            <div
                                                className={classNames(
                                                    "d-flex align-items-start rangedate-picker__container  px-2",
                                                    {
                                                        "w-100": !isDesktop,
                                                    },
                                                )}>
                                                <Field
                                                    component={RangeDatePicker}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="dueDates"
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {!isDesktop && (
                                                <I18n
                                                    component="p"
                                                    id={`${FORM_ID}.search.payDate.mobile.label`}
                                                    componentProps={{ className: "w-100 control-label mb-0 px-2" }}
                                                />
                                            )}
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="payDateFrom"
                                                    hidePlaceholder
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.payDateFrom.mobile.label`
                                                    }
                                                    startDate={payDateFrom}
                                                    handleChange={this.handleChangePayDateFrom}
                                                    endDate={payDateTo}
                                                    isRequired
                                                    minDate={null}
                                                    value={payDateFrom}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    hidePlaceholder
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.payDateTo.mobile.label`
                                                    }
                                                    idForm={`${FORM_ID}.search`}
                                                    name="payDateTo"
                                                    minDate={selectedPayDateFrom}
                                                    isRequired
                                                    value={payDateTo}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                            {!isDesktop && (
                                                <I18n
                                                    component="p"
                                                    id={`${FORM_ID}.search.dueDate.mobile.label`}
                                                    componentProps={{ className: "w-100 control-label mb-0 px-2" }}
                                                />
                                            )}
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="dueDateFrom"
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.dueDateFrom.mobile.label`
                                                    }
                                                    hidePlaceholder
                                                    startDate={dueDateFrom}
                                                    handleChange={this.handleChangeDueDateFrom}
                                                    endDate={dueDateTo}
                                                    isRequired
                                                    minDate={null}
                                                    value={dueDateFrom}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>

                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    hidePlaceholder
                                                    idForm={`${FORM_ID}.search`}
                                                    name="dueDateTo"
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.dueDateTo.mobile.label`
                                                    }
                                                    minDate={selectedDueDateFrom}
                                                    isRequired
                                                    value={dueDateTo}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {optionSelected === "2" && (
                                <>
                                    <div className="d-flex align-items-start select-container px-2">
                                        <Field
                                            component={Selector}
                                            options={operationsTypesOptions}
                                            idForm={`${FORM_ID}.search`}
                                            name="operationType"
                                            isRequired
                                            hidePlaceholder
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                        />
                                    </div>
                                    {enableRangeDatefield ? (
                                        <div
                                            className={classNames(
                                                "d-flex align-items-start rangedate-picker__container  px-2",
                                                {
                                                    "w-100": !isDesktop,
                                                },
                                            )}>
                                            <Field
                                                component={RangeDatePicker}
                                                idForm={`${FORM_ID}.search`}
                                                name="settlementDates"
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            {!isDesktop && (
                                                <I18n
                                                    component="p"
                                                    id={`${FORM_ID}.search.settlementDate.mobile.label`}
                                                    componentProps={{ className: "w-100 control-label mb-0 px-2" }}
                                                />
                                            )}
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="settlementDateFrom"
                                                    customKey={
                                                        isDesktop
                                                            ? false
                                                            : `${FORM_ID}.search.settlementDateFrom.mobile.label`
                                                    }
                                                    hidePlaceholder
                                                    startDate={settlementDateFrom}
                                                    handleChange={this.handleChangeSettlementDateFrom}
                                                    endDate={settlementDateTo}
                                                    isRequired
                                                    minDate={null}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>

                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    hidePlaceholder
                                                    idForm={`${FORM_ID}.search`}
                                                    name="settlementDateTo"
                                                    customKey={
                                                        isDesktop
                                                            ? false
                                                            : `${FORM_ID}.search.settlementDateTo.mobile.label`
                                                    }
                                                    minDate={selectedSettlementDateFrom}
                                                    isRequired
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {optionSelected === "3" && (
                                <>
                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={Selector}
                                            options={ecomexStatesOptions}
                                            idForm={`${FORM_ID}.search`}
                                            name="ecomexState"
                                            isRequired
                                            hidePlaceholder
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                        />
                                    </div>

                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={Selector}
                                            options={operationsTypesOptions}
                                            idForm={`${FORM_ID}.search`}
                                            name="operationType"
                                            isRequired
                                            hidePlaceholder
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                        />
                                    </div>
                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={TextField}
                                            hidePlaceholder
                                            idForm={`${FORM_ID}.search`}
                                            name="destination"
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                            maxLength={16}
                                        />
                                    </div>
                                    {enableRangeDatefield ? (
                                        <div
                                            className={classNames(
                                                "d-flex align-items-start rangedate-picker__container  px-2",
                                                {
                                                    "w-100": !isDesktop,
                                                },
                                            )}>
                                            <Field
                                                component={RangeDatePicker}
                                                idForm={`${FORM_ID}.search`}
                                                name="officialDates"
                                            />
                                        </div>
                                    ) : (
                                        <>
                                            {!isDesktop && (
                                                <I18n
                                                    component="p"
                                                    id={`${FORM_ID}.search.officialDate.mobile.label`}
                                                    componentProps={{ className: "w-100 control-label mb-0 px-2" }}
                                                />
                                            )}
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="officialDateFrom"
                                                    customKey={
                                                        isDesktop
                                                            ? false
                                                            : `${FORM_ID}.search.officialDateFrom.mobile.label`
                                                    }
                                                    hidePlaceholder
                                                    startDate={officialDateFrom}
                                                    handleChange={this.handleChangeOfficialDateFrom}
                                                    endDate={officialDateTo}
                                                    isRequired
                                                    minDate={null}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    hidePlaceholder
                                                    idForm={`${FORM_ID}.search`}
                                                    name="officialDateTo"
                                                    customKey={
                                                        isDesktop
                                                            ? false
                                                            : `${FORM_ID}.search.officialDateTo.mobile.label`
                                                    }
                                                    minDate={selectedOfficialDateFrom}
                                                    isRequired
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {optionSelected === "4" && (
                                <>
                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={Selector}
                                            options={ecomexStatesOptions}
                                            idForm={`${FORM_ID}.search`}
                                            name="ecomexState"
                                            isRequired
                                            hidePlaceholder
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                        />
                                    </div>
                                    <div className="d-flex align-items-start px-2">
                                        <Field
                                            component={TextField}
                                            hidePlaceholder
                                            idForm={`${FORM_ID}.search`}
                                            name="destination"
                                            formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                            maxLength={16}
                                        />
                                    </div>
                                    {enableRangeDatefield ? (
                                        <>
                                            <div
                                                className={classNames(
                                                    "d-flex align-items-start rangedate-picker__container  px-2",
                                                    {
                                                        "w-100": !isDesktop,
                                                    },
                                                )}>
                                                <Field
                                                    component={RangeDatePicker}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="embDates"
                                                />
                                            </div>
                                            <div
                                                className={classNames(
                                                    "d-flex align-items-start rangedate-picker__container  px-2",
                                                    {
                                                        "w-100": !isDesktop,
                                                    },
                                                )}>
                                                <Field
                                                    component={RangeDatePicker}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="dueDates"
                                                />
                                            </div>
                                        </>
                                    ) : (
                                        <>
                                            {!isDesktop && (
                                                <I18n
                                                    component="p"
                                                    id={`${FORM_ID}.search.embDate.mobile.label`}
                                                    componentProps={{ className: "w-100 control-label mb-0 px-2" }}
                                                />
                                            )}
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="embDateFrom"
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.embDateFrom.mobile.label`
                                                    }
                                                    hidePlaceholder
                                                    startDate={embDateFrom}
                                                    handleChange={this.handleChangeEmbDateFrom}
                                                    endDate={embDateTo}
                                                    isRequired
                                                    minDate={null}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>

                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    hidePlaceholder
                                                    idForm={`${FORM_ID}.search`}
                                                    name="embDateTo"
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.embDateTo.mobile.label`
                                                    }
                                                    minDate={selectedEmbDateFrom}
                                                    isRequired
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                            {!isDesktop && (
                                                <I18n
                                                    component="p"
                                                    id={`${FORM_ID}.search.dueDate.mobile.label`}
                                                    componentProps={{ className: "w-100 control-label mb-0 px-2" }}
                                                />
                                            )}
                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    idForm={`${FORM_ID}.search`}
                                                    name="dueDateFrom"
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.dueDateFrom.mobile.label`
                                                    }
                                                    hidePlaceholder
                                                    startDate={dueDateFrom}
                                                    handleChange={this.handleChangeDueDateFrom}
                                                    endDate={dueDateTo}
                                                    isRequired
                                                    minDate={null}
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>

                                            <div
                                                className={classNames("d-flex align-items-start px-2", {
                                                    "flex-50": !isDesktop,
                                                })}>
                                                <Field
                                                    component={DateField}
                                                    hidePlaceholder
                                                    idForm={`${FORM_ID}.search`}
                                                    name="dueDateTo"
                                                    customKey={
                                                        isDesktop ? false : `${FORM_ID}.search.dueDateTo.mobile.label`
                                                    }
                                                    minDate={selectedDueDateFrom}
                                                    isRequired
                                                    formGroupClassName={classNames("w-100", { "mb-0": isDesktop })}
                                                />
                                            </div>
                                        </>
                                    )}
                                </>
                            )}
                            {filterButton}
                        </div>
                    </Form>
                )}
                <div className={isDesktop ? "mt-2" : "mt-0"}>
                    <EcomexInformativeRegimeList isDesktop={isDesktop} />
                </div>
            </PageLoading>
        );
    }

    renderContent() {
        const { isDesktop, fetching, fetchingDownload, selectedInformativeRegime, embeddedInV3Shell } = this.props;
        const enabledEcomexInformativeRegimeSolicitud = configUtils.getBoolean(
            "frontend.ecomex.consultivo.RRII.solicitud.liquidacion",
            false,
        );

        const centerElement = () => (
            <div className="d-flex">
                <I18n
                    id="ecomex.informativeRegime.title"
                    component="h1"
                    componentProps={{
                        className: classNames("cmf-title-center font-size-28-px m-0", { "mr-4": isDesktop }),
                    }}
                />
                {enabledEcomexInformativeRegimeSolicitud && isDesktop && (
                    <Hint
                        size="big"
                        text={configUtils.get(
                            "frontend.operacion.tooltip.RRII.liquidable.ecomex.consultivo",
                            "Al ingresar a los registros, podrás generar solicitudes.",
                        )}
                    />
                )}
            </div>
        );

        if (selectedInformativeRegime) {
            return <EcomexInformativeRegimeDetail isDesktop={isDesktop} embeddedInV3Shell={embeddedInV3Shell} />;
        }

        if (embeddedInV3Shell && !isDesktop) {
            return (
                <PageLoading loading={fetching} className="screen-loader">
                    {this.rowButtons()}
                    {this.renderList()}
                </PageLoading>
            );
        }

        if (isDesktop) {
            return (
                <PageLoading loading={fetching} className="screen-loader">
                    <div className="admin-detail-head px-0 mb-0">
                        <Head onBack={this.handleBack} />
                        <Head
                            centerElement={centerElement}
                            isFetchingExport={fetchingDownload}
                            isMobile
                            exportList
                            handleClick={this.handleExport}
                            handleClickMessage="global.download"
                            csvDownload
                            xlsDownload
                            accessibilityTextId="ecomex.informativeRegime.title"
                            imageStyle="mr-2"
                        />
                        {this.rowButtons()}
                        {this.renderList()}
                    </div>
                </PageLoading>
            );
        }

        return (
            <div className="admin-detail-head px-0 d-block mb-0">
                <Head
                    centerElement={centerElement}
                    centerContentClassName="mx-5"
                    isFetchingExport={fetchingDownload}
                    exportList
                    handleClick={this.handleExport}
                    handleClickMessage="global.download"
                    onBack={this.handleBack}
                    headerClassName="blue-main-header-mobile"
                    accessibilityTextId="ecomex.informativeRegime.title"
                    downloadImageWhite
                    uniqueDownload
                />
                {enabledEcomexInformativeRegimeSolicitud && isDesktop && (
                    <div className="m-3">
                        <Hint
                            size="big"
                            text={configUtils.get(
                                "frontend.operacion.tooltip.RRII.liquidable.ecomex.consultivo",
                                "Al ingresar a los registros, podrás generar solicitudes.",
                            )}
                        />
                    </div>
                )}
                <PageLoading loading={fetching} className="screen-loader">
                    {this.rowButtons()}
                    {this.renderList()}
                </PageLoading>
            </div>
        );
    }

    render() {
        const { isDesktop, embeddedInV3Shell } = this.props;

        return (
            <>
                {!embeddedInV3Shell && (
                    <Notification
                        scopeToShow={FORM_ID}
                        notificationClassname={classNames({ "navbar-fixed-top": !isDesktop })}
                    />
                )}
                {this.renderContent()}
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    fetching: ecomexSelectors.getFetching(state),
    fetchingDownload: ecomexSelectors.getFetchingDownload(state),
    ecomexInformativeRegime: ecomexSelectors.getEcomexInformativeRegime(state),
    filtersData: ecomexSelectors.getFiltersData(state),
    optionSelected: ecomexSelectors.getOptionSelected(state),
    selectedInformativeRegime: ecomexSelectors.getSelectedInformativeRegime(state),
    pageNumber: ecomexSelectors.getPageNumber(state),
    numberPerPage: ecomexSelectors.getNumberPerPage(state),
    operationsTypes: ecomexSelectors.getOperationsTypes(state),
    ecomexStates: ecomexSelectors.getEcomexStates(state),
    optionSelectedFromPre: ecomexSelectors.getOptionSelectedFromPre(state),
});

export default compose(
    connect(mapStateToProps),
    withFormik({
        validateOnChange: true,
        validateOnBlur: true,
        mapPropsToValues: (props) => {
            const { ecomexStates, operationsTypes } = props;
            return {
                ecomexState: ecomexStates && "V",
                operationType: operationsTypes && operationsTypes[0] && operationsTypes[0].value,
                destination: "",
                operationNumber: "",
                payDateFrom: null,
                payDateTo: null,
                payDates: [null, null],
                dueDateFrom: null,
                dueDateTo: null,
                dueDates: [null, null],
                settlementDateFrom: DATE_FROM,
                settlementDateTo: DATE_TO,
                settlementDates: [DATE_FROM, DATE_TO],
                officialDateFrom: DATE_FROM,
                officialDateTo: DATE_TO,
                officialDates: [DATE_FROM, DATE_TO],
                embDateFrom: DATE_FROM,
                embDateTo: DATE_TO,
                embDates: [DATE_FROM, DATE_TO],
            };
        },
        validationSchema: () =>
            Yup.lazy((values) =>
                Yup.object().shape({
                    payDateFrom: values.payDateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.payDateTo, i18nUtils.get(`${FORM_ID}.search.minDate.error`))
                        : Yup.date().nullable(),
                    payDateTo: values.payDateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.payDateFrom, i18nUtils.get(`${FORM_ID}.search.maxDate.error`))
                        : Yup.date().nullable(),
                    dueDateFrom: values.dueDateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.dueDateTo, i18nUtils.get(`${FORM_ID}.search.minDate.error`))
                        : Yup.date().nullable(),
                    dueDateTo: values.dueDateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.dueDateFrom, i18nUtils.get(`${FORM_ID}.search.maxDate.error`))
                        : Yup.date().nullable(),
                    settlementDateFrom: values.settlementDateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.settlementDateTo, i18nUtils.get(`${FORM_ID}.search.minDate.error`))
                        : Yup.date().nullable(),
                    settlementDateTo: values.settlementDateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.settlementDateFrom, i18nUtils.get(`${FORM_ID}.search.maxDate.error`))
                        : Yup.date().nullable(),
                    officialDateFrom: values.officialDateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.officialDateTo, i18nUtils.get(`${FORM_ID}.search.minDate.error`))
                        : Yup.date().nullable(),
                    officialDateTo: values.officialDateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.officialDateFrom, i18nUtils.get(`${FORM_ID}.search.maxDate.error`))
                        : Yup.date().nullable(),
                    embDateFrom: values.embDateTo
                        ? Yup.date()
                              .nullable()
                              .max(values.embDateTo, i18nUtils.get(`${FORM_ID}.search.minDate.error`))
                        : Yup.date().nullable(),
                    embDateTo: values.embDateFrom
                        ? Yup.date()
                              .nullable()
                              .min(values.embDateFrom, i18nUtils.get(`${FORM_ID}.search.maxDate.error`))
                        : Yup.date().nullable(),
                }),
            ),
        handleSubmit: (
            {
                ecomexState,
                operationType,
                destination,
                operationNumber,
                payDateFrom,
                payDateTo,
                payDates,
                dueDateFrom,
                dueDateTo,
                dueDates,
                officialDateFrom,
                officialDateTo,
                officialDates,
                settlementDateFrom,
                settlementDateTo,
                settlementDates,
                embDateFrom,
                embDateTo,
                embDates,
            },
            formikBag,
        ) => {
            const { dispatch, optionSelected, numberPerPage } = formikBag.props;
            const enableRangeDatefield = configUtils.getBoolean("frontend.show.RangeDatePicker.functionalities", false);
            dispatch(
                ecomexActions.listEcomexInformativeRegime(
                    1,
                    numberPerPage,
                    optionSelected,
                    ecomexState,
                    operationType,
                    destination,
                    operationNumber,
                    enableRangeDatefield ? payDates[0] : payDateFrom,
                    enableRangeDatefield ? payDates[1] : payDateTo,
                    enableRangeDatefield ? dueDates[0] : dueDateFrom,
                    enableRangeDatefield ? dueDates[1] : dueDateTo,
                    enableRangeDatefield ? officialDates[0] : officialDateFrom,
                    enableRangeDatefield ? officialDates[1] : officialDateTo,
                    enableRangeDatefield ? settlementDates[0] : settlementDateFrom,
                    enableRangeDatefield ? settlementDates[1] : settlementDateTo,
                    enableRangeDatefield ? embDates[0] : embDateFrom,
                    enableRangeDatefield ? embDates[1] : embDateTo,
                ),
            );
        },
    }),
    resizableRoute,
)(EcomexInformativeRegimeMain);
